import axios from 'axios';

export function getStatisticsMonitor(from, until) {
    return axios({
        method: 'POST',
        url: '/api/v1/statistics/monitor',
        data: {
            from,
            until,
        },
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}


// WEBPACK FOOTER //
// ./app/services/statistics/monitor.js